// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1SfcP","signatureBlock":"Footer_signatureBlock__2653D","signature":"Footer_signature__2db49"};